import React from 'react';
var langRes;
// if (process.env.LOCALE === 'cn') {
//     langRes = require('./cn').default;
// } else if (process.env.LOCALE === 'jp') {
//     langRes = require('./jp').default;
// } else {
    langRes = require('./en').default;
// }
export default function translate(key) {
    return Component => {
        class TranslationComponent extends React.Component {
            render() {
                const lang = this.context.currentLanguage || 'en';
                if (lang) {
                    let strings = langRes[key] || {};
                    if (key === 'HomePage') {
                        strings['homeSections'] = langRes['homeSections'];
                    } else if (key === 'quickStart') {
                        strings['quickStart'] = langRes['QuickStartPage'];
                    } else if (key === 'NaviTree' || key === 'DemoPage') {
                        strings['demo_intl'] = langRes['demos'];
                    }
                    const merged = {...this.props.strings, ...strings };
                    if (strings) {
                        return (
                            <Component {...this.props}
                          strings={merged}
                          currentLanguage={lang}
                        />
                        );
                    }

                    return (
                        <Component {...this.props}
                      currentLanguage={lang}
                    />
                    );
                }
                return (
                    <Component {...this.props}
                      currentLanguage={this.context.currentLanguage}
                    />
                );
            }
        }

        TranslationComponent.contextTypes = {
            currentLanguage: React.PropTypes.string
        };

        TranslationComponent.propTypes = {
            strings: React.PropTypes.object
        };

        return TranslationComponent;
    };
}



// WEBPACK FOOTER //
// ./i18n/translate.js